/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  // Announcement bar count down timer
  const announcementTimerEls = document.querySelectorAll('.announcement__timer');
  if (announcementTimerEls) {
    announcementTimerEls.forEach(announcementTimerEl => {
      const daysEl = announcementTimerEl.querySelector('[data-timer="days"]');
      const hoursEl = announcementTimerEl.querySelector('[data-timer="hours"]');
      const minutesEl = announcementTimerEl.querySelector('[data-timer="minutes"]');
      const secondsEl = announcementTimerEl.querySelector('[data-timer="seconds"]');
      const endedMessageEl = announcementTimerEl.querySelector('[data-timer="ended-message"]');

      const countDownDate = new Date(announcementTimerEl.dataset.endTime).getTime();

      const countDownInterval = setInterval(function () {
        const now = new Date().getTime();
        const timeDifference = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        // update count down elements
        if (days == 0) {
          daysEl.classList.add('hidden'); 
        } else if (days == 1) {
          daysEl.textContent = days + " day ";
        } else {
          daysEl.textContent = days + " days ";
        }

        hoursEl.textContent = ("00" + hours).slice(-2);
        minutesEl.textContent = ("00" + minutes).slice(-2);
        secondsEl.textContent = ("00" + seconds).slice(-2);

        // count down ended, show end message
        if (timeDifference < 0) {
          clearInterval(countDownInterval);
          const endedMessageVal = endedMessageEl.textContent;

          if (endedMessageVal.length != 0) {
            // if has a message, replace the content of this slide
            announcementTimerEl.closest('.count-down__ended > p').textContent = endedMessageVal;
          } else if (announcementTimerEl.closest(".announcement__slide") != null) {
            //hide the slide with the expired countdown
            //announcementTimerEl.closest(".announcement__slide").style.display = "none";
            announcementTimerEl.style.display = "none";
          } else {
            //only one announcement
            announcementTimerEl.closest(".page-announcement").classList.add('hidden');
          }
        }
      }, 1000);
    });
  }



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
